<template>
  <div class="add-usuario">
    <h1>Agregar Nuevo Usuario</h1>
    
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <form @submit.prevent="createUsuario" class="mt-4">
      <div class="mb-3">
        <label for="usuario_id" class="form-label">ID de Usuario *</label>
        <input 
          type="text" 
          class="form-control" 
          id="usuario_id" 
          :value="usuario.UsuarioId"
          @input="updateField('UsuarioId', $event.target.value)"
          required
          maxlength="20"
        >
        <small class="form-text text-muted">Mu00e1ximo 20 caracteres</small>
      </div>
      
      <div class="mb-3">
        <label for="password" class="form-label">Contraseu00f1a *</label>
        <input 
          type="password" 
          class="form-control" 
          id="password" 
          :value="usuario.Password"
          @input="updateField('Password', $event.target.value)"
          required
          maxlength="40"
        >
        <small class="form-text text-muted">Mu00e1ximo 40 caracteres</small>
      </div>
      
      <div class="mb-3">
        <label for="nombre" class="form-label">Nombre</label>
        <input 
          type="text" 
          class="form-control" 
          id="nombre" 
          :value="usuario.Nombre"
          @input="updateField('Nombre', $event.target.value)"
          maxlength="60"
        >
        <small class="form-text text-muted">Mu00e1ximo 60 caracteres</small>
      </div>
      
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input 
          type="email" 
          class="form-control" 
          id="email" 
          :value="usuario.Email"
          @input="updateField('Email', $event.target.value)"
          maxlength="80"
        >
        <small class="form-text text-muted">Mu00e1ximo 80 caracteres</small>
      </div>
      
      <div class="mb-3 form-check">
        <input 
          type="checkbox" 
          class="form-check-input" 
          id="es_activo" 
          :checked="usuario.EsActivo"
          @change="updateField('EsActivo', $event.target.checked)"
        >
        <label class="form-check-label" for="es_activo">Usuario Activo</label>
      </div>
      
      <div class="mb-3">
        <label for="zempleado" class="form-label">ZEmpleado</label>
        <input 
          type="text" 
          class="form-control" 
          id="zempleado" 
          :value="usuario.zEmpleado"
          @input="updateField('zEmpleado', $event.target.value)"
          maxlength="20"
        >
        <small class="form-text text-muted">Mu00e1ximo 20 caracteres</small>
      </div>
      
      <div class="mb-3">
        <label for="zserie" class="form-label">ZSerie</label>
        <input 
          type="text" 
          class="form-control" 
          id="zserie" 
          :value="usuario.zSerie"
          @input="updateField('zSerie', $event.target.value)"
          maxlength="20"
        >
        <small class="form-text text-muted">Mu00e1ximo 20 caracteres</small>
      </div>
      
      <div class="mb-3">
        <label for="usuario_id_consulta" class="form-label">Usuario ID Consulta</label>
        <input 
          type="text" 
          class="form-control" 
          id="usuario_id_consulta" 
          :value="usuario.usuario_id_consulta"
          @input="updateField('usuario_id_consulta', $event.target.value)"
          maxlength="200"
        >
        <small class="form-text text-muted">Mu00e1ximo 200 caracteres</small>
      </div>
      
      <div class="d-flex gap-2">
        <button type="submit" class="btn btn-primary" :disabled="saving">
          <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          <i v-else class="bi bi-save me-1"></i>
          Guardar
        </button>
        <router-link to="/config/usuarios" class="btn btn-secondary">
          <i class="bi bi-x-circle me-1"></i> Cancelar
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import { AddUsuarioController } from '../controllers/AddUsuarioCtrl.js';

export default {
  name: 'AddUsuarioView',
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new AddUsuarioController()
    }
  },
  computed: {
    usuario: {
      get() {
        return this.controller.getUsuario();
      },
      set(value) {
        // Este setter permite la reactividad bidireccional
        Object.keys(value).forEach(key => {
          this.controller.updateField(key, value[key]);
        });
      }
    },
    saving() {
      return this.controller.isSaving();
    },
    error() {
      return this.controller.getError();
    }
  },
  mounted() {
    this.controller.init();
  },
  methods: {
    async createUsuario() {
      try {
        await this.controller.createUsuario();
        this.$router.push('/config/usuarios');
      } catch (error) {
        // El error ya está manejado en el controlador
        console.error('Error al crear usuario:', error);
      }
    },
    updateField(field, value) {
      this.controller.updateField(field, value);
    }
  }
}
</script>

<style scoped>
.add-usuario {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
